<style scoped>
    .info_page {
        background: #f7f7f7;
    }

    .info_tips {
        width: 100%;
        height: 0.36rem;
        background: #e6ebff;
        color: #5983fc;
        font-size: 0.14rem;
        text-align: center;
        line-height: 0.36rem;
    }

    .user_info {
        background: #ffffff;
    }

    .user_ingo_line {
        width: 0.04rem;
        height: 0.13rem;
        background: linear-gradient(
                135deg,
                rgba(89, 131, 252, 1) 0%,
                rgba(60, 113, 246, 1) 100%
        );
        display: inline-block;
    }

    .user_info_title {
        height: 0.42rem;
        padding: 0 0.15rem;
        display: flex;
        align-items: center;
        border-bottom: 0.01rem solid #f5f5f5;
    }

    .user_info_txt {
        margin-left: 0.06rem;
        color: #333333;
        font-weight: bold;
        font-size: 0.14rem;
    }

    .choose_user_info {
        padding: 0 0.15rem;
    }

    .user_box {
        width: 100%;
        height: 0.5rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #333333;
        font-size: 0.14rem;
    }

    .user_box_bot {
        border-bottom: 0.01rem solid #f5f5f5;
    }

    .user_box_right {
        display: flex;
        align-items: center;
    }

    .user_box_right img {
        width: 0.1rem;
        height: 0.1rem;
        margin-left: 0.1rem;
    }

    .choose_color {
        color: #999999;
    }

    >>> .van-cell {
        padding: 0.1rem 0.05rem;
        width: 80%;
    }

    >>> .van-field__control--right::-webkit-input-placeholder {
        color: #adadad;
        font-size: 0.14rem;
    }

    .income_info {
        background: #ffffff;
        margin-top: 0.1rem;
        padding-bottom: 0.3rem;
    }

    .choose_income {
        padding: 0 0.15rem;
    }

    .choose_title {
        padding: 0.2rem 0 0.05rem 0;
    }

    .choose_box {
        /* width: 1.08rem; */
        width: 100%;
        height: 0.3rem;
        border-radius: 0.02rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 0.1rem;
        border: 0.01rem solid rgba(204, 204, 204, 1);
        color: #999999;
        font-size: 0.14rem;
        text-align: center;
    }

    .cred_card {
        height: 0.48rem;
    }

    .cred_card_font {
        font-size: 0.12rem;
    }

    .cred_card_font2 {
        font-size: 0.12rem;
    }

    .click_box {
        background: rgba(79, 140, 250, 0.1);
        border: 0.01rem solid rgba(79, 140, 250, 1);
        color: #4f8cfa;
        font-weight: bold;
    }

    .last_bot {
        padding-bottom: 0.2rem;
    }

    .btn {
        /* margin-top: 0.1rem; */
        width: 100%;
        height: 0.5rem;
        background: linear-gradient(
                132deg,
                rgba(89, 163, 252, 1) 0%,
                rgba(60, 100, 246, 1) 100%
        );
        font-size: 0.17rem;
        color: #ffffff;
        font-weight: bold;
        line-height: 0.5rem;
        text-align: center;
    }

    >>> .van-col--8:nth-child(3n + 2),
    .van-col--8:nth-child(3n + 3) {
        padding-left: 0.08rem;
    }


    .toast {
        font-family: PingFangSC-Medium, PingFang SC;
        width: 3rem;
        text-align: center;
    }

    .toast .title {
        font-size: 0.21rem;
        font-weight: 500;
        color: #333333;
        margin-top: 0.26rem;
    }

    .toast .subTitle {
        font-size: 0.13rem;
        font-weight: 400;
        color: #FF514A;
        margin: 0.12rem 0 0.23rem 0;
    }

    .toast input {
        width: 2.61rem;
        height: 0.5rem;
        background: #F5F5F5;
        border-radius: 0.08rem;
        text-indent: 0.08rem;
    }

    .toast .toastBtn {
        width: 2.61rem;
        height: 0.5rem;
        background: linear-gradient(132deg, #59A3FC 0%, #3C64F6 100%);
        border-radius: 0.25rem;
        margin: 0.23rem auto 0.06rem;
        line-height: 0.5rem;
        font-size: 0.18rem;
        font-weight: 500;
        color: #fff;
    }

    .toast .skip {
        font-size: 0.16rem;
        font-weight: 500;
        color: #999;
        margin-bottom: 0.15rem;
        padding: 3px;
    }

    input::-webkit-input-placeholder { /* WebKit browsers */
        font-size: 0.14rem;
        color: #999;
    }

    .carToastNew .title {
        font-size: 0.12rem;
        font-weight: 400;
        color: #E92323;
        margin: 0.1rem 0;
    }

    .carToastNew .model {
        font-size: 0.14rem;
        font-weight: 400;
        color: #333333;
        margin-left: 0.07rem;
    }

    .agree {
        display: flex;
        padding: 0.11rem 0.1rem 0.15rem 0.15rem;
        font-size: 0.1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    .agree .img {
        width: 0.12rem;
        height: 0.12rem;
        margin-right: 4px;
        margin-top: 1px;
    }

</style>
<template>
    <div class="info_page">
        <div class="info_tips">信息仅用于审批借款额度，资料将被加密保护</div>
        <div class="user_info">
            <div class="user_info_title">
                <div class="user_ingo_line"></div>
                <span class="user_info_txt">个人信息</span>
            </div>
            <div class="choose_user_info">
                <div class="user_box user_box_bot"
                     @click="showEducationPicker = true">
                    <div>学历</div>
                    <div class="user_box_right">
            <span v-if="education == ''"
                  class="choose_color">请选择</span>
                        <span v-else>{{ education }}</span>
                        <img src="@/assets/img/vip/right_tip.png"
                             alt=""/>
                    </div>
                </div>
                <van-popup v-model="showEducationPicker"
                           round
                           position="bottom">
                    <van-picker show-toolbar
                                :columns="educations"
                                @cancel="showEducationPicker = false"
                                @confirm="onConfirmEducation"/>
                </van-popup>

                <!--<div class="user_box user_box_bot"
                     @click="showLoanConditionPicker = true">
                    <div>近30天借款信息</div>
                    <div class="user_box_right">
            <span v-if="loanCondition == ''"
                  class="choose_color">请选择</span>
                        <span v-else>{{ loanCondition }}</span>
                        <img src="@/assets/img/vip/right_tip.png"
                             alt=""/>
                    </div>
                </div>
                <van-popup v-model="showLoanConditionPicker"
                           round
                           position="bottom">
                    <van-picker show-toolbar
                                :columns="loanConditions"
                                @cancel="showLoanConditionPicker = false"
                                @confirm="onConfirmLoanCondition"/>
                </van-popup>-->

                <!--<div class="user_box user_box_bot"
                     @click="showCreditRecordPicker = true">
                    <div>信用记录</div>
                    <div class="user_box_right">
            <span v-if="creditRecord == ''"
                  class="choose_color">请选择</span>
                        <span v-else>{{ creditRecord }}</span>
                        <img src="@/assets/img/vip/right_tip.png"
                             alt=""/>
                    </div>
                </div>
                <van-popup v-model="showCreditRecordPicker"
                           round
                           position="bottom">
                    <van-picker show-toolbar
                                :columns="creditRecords"
                                @cancel="showCreditRecordPicker = false"
                                @confirm="onConfirmCreditRecord"/>
                </van-popup>-->

                <!-- 借款金额 -->
                <div
                        class="user_box user_box_bot"
                        @click="showMoneyPicker = true"
                >
                    <div>借款金额</div>
                    <div class="user_box_right">
                        <span v-if="userMoney==''" class="choose_color">请选择</span>
                        <span v-else>{{userMoney}}</span>
                        <img src="@/assets/img/vip/right_tip.png" alt=""/>
                    </div>
                </div>
                <van-popup v-model="showMoneyPicker" round position="bottom">
                    <van-picker
                            show-toolbar
                            :columns="columnsMoney"
                            @cancel="showMoneyPicker = false"
                            @confirm="onConfirmMoney"
                    />
                </van-popup>
                <!-- 借款期限 -->
                <div class="user_box user_box_bot" @click="showDatePicker = true">
                    <div>借款期限</div>
                    <div class="user_box_right">
                        <span v-if="userDate==''" class="choose_color">请选择</span>
                        <span v-else>{{userDate}}</span>
                        <img src="@/assets/img/vip/right_tip.png" alt=""/>
                    </div>
                </div>
                <van-popup v-model="showDatePicker" round position="bottom">
                    <van-picker
                            show-toolbar
                            :columns="columnsDate"
                            @cancel="showDatePicker = false"
                            @confirm="onConfirmDate"
                    />
                </van-popup>
            </div>
        </div>
        <div class="user_info" v-if="workInfoShow" style="margin-top: 5px;">
            <div class="user_info_title">
                <div class="user_ingo_line"></div>
                <span class="user_info_txt">工作信息</span>
            </div>
            <div class="choose_user_info">

                <!-- 工作地址 -->
                <div class="user_box user_box_bot" @click="choiceCity">
                    <div>所在地区</div>
                    <div class="user_box_right">
                        <span v-if="userCity==''" class="choose_color">请选择</span>
                        <span v-else>{{ userCity }}</span>
                        <img src="@/assets/img/vip/right_tip.png" alt=""/>
                    </div>
                </div>
                <van-popup v-model="showCityChoose" round position="bottom">
                    <van-area
                            title="请选择地区"
                            :area-list="areaList"
                            @cancel="showCityChoose = false"
                            @confirm="confirmCity"
                    />
                </van-popup>
                <div class="user_box user_box_bot"
                     @click="showUsePicker = true">
                    <div>借款用途</div>
                    <div class="user_box_right">
            <span v-if="useValue == ''"
                  class="choose_color">请选择</span>
                        <span v-else>{{ useValue }}</span>
                        <img src="@/assets/img/vip/right_tip.png"
                             alt=""/>
                    </div>
                </div>
                <van-popup v-model="showUsePicker"
                           round
                           position="bottom">
                    <van-picker show-toolbar
                                :columns="columnsUser"
                                @cancel="showUsePicker = false"
                                @confirm="onConfirmUser"/>
                </van-popup>
                <div class="user_box user_box_bot"
                     @click="showPerPicker = true">
                    <div>职业身份</div>
                    <div class="user_box_right">
            <span v-if="perValue == ''"
                  class="choose_color">请选择</span>
                        <span v-else>{{ perValue }}</span>
                        <img src="@/assets/img/vip/right_tip.png"
                             alt=""/>
                    </div>
                </div>
                <van-popup v-model="showPerPicker"
                           round
                           position="bottom">
                    <van-picker show-toolbar
                                :columns="columnsPer"
                                @cancel="showPerPicker = false"
                                @confirm="onConfirmPer"/>
                </van-popup>
                <div class="user_box">
                    <div>{{ showSampleTxt == true ? "月收入" : "总经营流水" }}</div>
                    <div class="user_box_right ">
                        <van-field v-model="incomeValue"
                                   placeholder="请输入"
                                   type="number"
                                   input-align="right"/>
                        <span>元/月</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="income_info"
             v-if="allList.length">
            <div class="user_info_title">
                <div class="user_ingo_line"></div>
                <span class="user_info_txt">资产信息</span>
            </div>
            <div class="choose_income">
                <div class="choose"
                     v-for="(item, index) in allList"
                     :key="index">
                    <p class="choose_title">{{ item.title }}</p>
                    <van-row>
                        <van-col span="8"
                                 v-for="(txt, num) in item.arr"
                                 :key="num">
                            <div class="choose_box "
                                 @click="clickTxt(txt, num, index)"
                                 :class="{
                  click_box: newNum[index].num == num,
                  cred_card_font: txt.length > 10,
                  cred_card: item.hasLonger == 1,
                }">
                                {{ txt }}
                            </div>
                        </van-col>
                    </van-row>

                    <div class="carToastNew" v-if="item.title=='车辆情况' && showCarModel" v-model="showCarModel">
                        <p class="title">*补充真实的车辆信息，可提高借款通过率 (选填)</p>
                        <div style="margin-bottom: 10px;">
                            <span class="model">品牌型号</span><input style="margin-left: 10px;" placeholder="如奥迪A4、大众帕萨特"
                                                                  v-model="carModel"></input>
                        </div>
                        <hr>
                    </div>

                </div>
            </div>
        </div>

        <!--  机构弹框 -->
        <AgencyToast v-if="agencyToastShow" :agencyListInfo="agencyListInfo" :isShowLoading="isShowLoading"
                     @xgfaMethod="xgfaMethod"></AgencyToast>

        <!--   车型弹框  -->
        <van-popup v-model:show="showToast" round closeable :close-on-click-overlay="false" @close="closeToast">
            <div class="toast">
                <p class="title">请填写车辆型号</p>
                <p class="subTitle">补充真实的车辆信息 可提高借款通过率</p>
                <input placeholder="请输入车辆型号，如奥迪A4、大众途昂" v-model="carModel"/>

                <div class="toastBtn" @click="toastSubmit">
                    确认提交
                </div>

                <button class="skip" @click="skipSubmit">
                    跳过
                </button>
            </div>
        </van-popup>

        <Loading :isShow="isCarLoading"></Loading>

        <div v-if="JSON.stringify(agreement)!='{}'">
            <!--<div>我已阅读并同意<a :href="agreement.url">{{agreement.name}}</a></div>-->
            <div class="agree">
                <div v-if="xy_selected" class="img">
                    <img src="@/assets/img/vip/selected.png"
                         style="width: 100%;height: 100%;"
                         @click="xy_selected=!xy_selected">
                </div>
                <div v-else class="img">
                    <img src="@/assets/img/vip/no_select.png" style="width: 100%;height: 100%;"
                         @click="xy_selected=!xy_selected">
                </div>
                申请即代表阅读并同意<span style="color: #3B72FF;">《个人信息授权书》</span>
            </div>
        </div>

        <!-- btn -->
        <div class="btn"
             @click="submit">
            提交
        </div>

    </div>
</template>

<script>
    import AgencyToast from '@/components/agencyToast.vue'
    import areaList from '../../libs/area.js'
    import Loading from "@/components/loading";

    export default {
        components: {AgencyToast, Loading},
        data() {
            return {
                authId: 32,
                areaList, //地区列表
                province: "", //省
                city: "", //城市
                area: "", //区
                provinceCode: "", //省编号
                cityCode: "", //市编号
                areaCode: "", //区/县编号
                useValue: "消费贷", //借款用途
                perValue: "", //身份
                showUsePicker: false,
                showPerPicker: false,
                showSampleTxt: true, //月收入
                columnsUser: [], //借款用途列表
                columnsPer: [], //职业身份列表
                incomeValue: "", //收入
                allList: [], //资产信息列表
                newNum: [],
                tips: "未完善，请填写完整后再保存~",
                showCityChoose: false, //选择城市列表
                userCity: "", //选择城市
                userMoney: "", //用户借款金额
                userDate: "", //用户借款期限
                showMoneyPicker: false, //选择借款金额
                showDatePicker: false, //选择借款期限
                columnsMoney: [], //借款金额列表
                columnsDate: [], //借款期限列表
                productId: "",
                loginPhone: "",
                pageUrl: "",
                agencyListInfo: [],  //机构信息
                isShowLoading: true, //机构组件的是否加载
                agencyToastShow: false, //机构是否显示
                showToast: false,
                carModel: "",
                isCarLoading: false,
                carSituation: "",
                showCarModel: false,
                hasLocation: false,
                education: "",  //学历
                educations: [], //学历选项
                loanCondition: "没有申请过贷款",  //近30天借款情况
                loanConditions: [], //近30天借款情况集合
                creditRecord: "无逾期", //信用记录
                creditRecords: [], //信用记录集合
                showEducationPicker: false,
                showLoanConditionPicker: false,
                showCreditRecordPicker: false,
                workInfoShow: false,
                agreement: {},
                xy_selected: false,
                source: 0,
            };
        },
        created() {
            this.productId = this.$route.query.productId;
            this.source = this.$route.query.source;
            this.startLocation();
            window.saveLocation = this.saveLocation;
            this.getUserInfo();
            this.getAgreement();
            //this.getNewInfo();
            //this.getAgencyListInfo();
        },
        mounted() {
            this.util.title("资产信息认证");
        },
        methods: {
            getUserInfo() {
                //获取基本信息
                this.$get("/app/v1/xinshen/queryByXinShenList", {
                    parentId: -1
                }).then((res) => {
                    console.log(res.data);
                    if (res.code == 200) {
                        console.log(res.data)

                        let baseInfo = res.data.base_info;
                        for (var i = 0; i < baseInfo.length; i++) {
                            if (baseInfo[i] && baseInfo[i].paramField.includes("education")) {
                                baseInfo[i].showConfig.split(",").forEach((item, index) => {
                                    this.educations.push({num: index, text: item});
                                });
                            }
                            if (baseInfo[i] && baseInfo[i].paramField.includes("loan_condition")) {
                                baseInfo[i].showConfig.split(",").forEach((item, index) => {
                                    this.loanConditions.push({num: index, text: item});
                                });
                            }
                            if (baseInfo[i] && baseInfo[i].paramField.includes("loan_record")) {
                                baseInfo[i].showConfig.split(",").forEach((item, index) => {
                                    this.creditRecords.push({num: index, text: item});
                                });
                            }
                            if (baseInfo[i] && baseInfo[i].paramField.includes("loan_moneys")) {
                                baseInfo[i].showConfig.split(",").forEach((item, index) => {
                                    this.columnsMoney.push({num: index, text: item});
                                });
                            }
                            if (baseInfo[i] && baseInfo[i].paramField.includes("loan_period")) {
                                baseInfo[i].showConfig.split(",").forEach((item, index) => {
                                    this.columnsDate.push({num: index, text: item});
                                });
                            }
                        }
                    } else {
                        this.util.toast({msg: res.message, type: "fail"});
                    }
                });
            },
            getWorkInfo() {
                //获取基本信息
                this.$get("/app/v1/xinshen/queryByXinShenList", {
                    parentId: 0
                }).then((res) => {
                    console.log(res.data);
                    if (res.code == 200) {
                        //借款用途
                        res.data.base_info[0].showConfig.split(",").forEach((item, index) => {
                            this.columnsUser.push({num: index, text: item});
                        });
                        //职业身份
                        res.data.base_info[1].showConfig.split(",").forEach((item, index) => {
                            this.columnsPer.push({
                                num: index,
                                text: item,
                                id: res.data.base_info[1].id,
                            });
                        });
                    } else {
                        this.util.toast({msg: res.message, type: "fail"});
                    }
                });
            },
            getList(id, name) {
                //获取资产信息
                this.$get("/app/v1/xinshen/queryByXinShenList", {
                    parentId: id,
                    assetName: name,
                    filter: 0
                }).then((res) => {
                    if (res.code == 200) {
                        let arr = [];
                        this.allList = [];
                        this.newNum = [];
                        res.data.asset_info.forEach((item, index) => {
                            this.allList.push({
                                title: item.name,
                                arr: item.showConfig.split(","),
                                hasLonger: item.hasLonger,
                            });
                            this.newNum.push({num: -1, title: item.name});
                        });
                    } else {
                        this.util.toast({msg: res.message, type: "fail"});
                    }
                });
            },
            getAgreement() {
                //获取协议
                this.$get("/app/api/v1/queryAgreement", {
                    authId: this.authId,
                }).then((res) => {
                    if (res.code == 200) {
                        console.log(res.data)
                        this.agreement = res.data;
                    } else {
                        this.util.toast({msg: res.message, type: "fail"});
                    }
                });
            },
            agreementLink() {
                window.location.href = this.agreement.url;
            },
            clickTxt(name, num, index) {
                //选择资产信息
                this.newNum[index].num = num;
                this.newNum[index]["name"] = name;
                this.newNum[index]["num"] = this.newNum[index].num;
                /*if (name.includes("有车")) {
                    this.checkCarToast();
                } else {
                    this.showCarModel = false;
                }*/
            },
            onConfirmEducation(value) {
                //选择学历
                this.education = value.text;
                this.showEducationPicker = false;
            },
            onConfirmLoanCondition(value) {
                //选择近30天借款信息
                this.loanCondition = value.text;
                this.showLoanConditionPicker = false;
            },
            onConfirmCreditRecord(value) {
                //选择近30天借款信息
                this.creditRecord = value.text;
                this.showCreditRecordPicker = false;
            },
            onConfirmUser(value) {
                //选择借款用途
                this.useValue = value.text;
                this.showUsePicker = false;
            },
            onConfirmPer(value) {
                //选择职业身份
                if (value.text == "企业主" || value.text == "个体户") {
                    this.showSampleTxt = false;
                } else {
                    this.showSampleTxt = true;
                }
                this.perValue = value.text;
                this.showPerPicker = false;
                this.getList(value.id, this.perValue);
            },
            submit() {
                if (JSON.stringify(this.agreement) != '{}') {
                    if (!this.xy_selected) {
                        this.util.toast({msg: "请先勾选协议"});
                        return;
                    }
                }
                //提交
                Promise.all([this.authXindai(), this.saveCustomerBaseInfo()]).then(
                    (res1) => {
                        if (res1[0].code == 200 && res1[1].code == 200) {
                            if (res1[0].data == "认证成功" && res1[1].data == 1) {
                                if (this.source == 1) {
                                    this.postOrder();
                                } else {
                                    this.authSuccess();
                                }
                                /*let param = {
                                    key: "agency_toast_switch"
                                }
                                this.$get('/app/api/v1/config/getValue', param)
                                    .then(res => {
                                        var e = res;
                                        if (e.code == 200 && e.data == 1) {
                                            this.getAgencyListInfo();
                                        } else {
                                            console.log("车辆条件" + this.carSituation)
                                            if (this.carSituation.includes("有车")) {
                                                this.checkCarToast();
                                            } else {
                                                this.authSuccess();
                                            }
                                        }
                                    })
                                    .catch(error => {
                                    });*/
                                //this.getAgencyListInfo();
                            }
                        } else {
                            if (res1[0].code == 500) {
                                this.$toast(res1[0].message);
                            } else if (res1[1].code == 500) {
                                this.$toast(res1[1].message);
                            }
                        }
                    }
                );
            },
            confirmCity(value) {
                if (value[2]) {
                    if (value[2].name === "请选择") {
                        this.showCityChoose = false;
                    } else {
                        this.province = value[0].name;
                        this.provinceCode = value[0].code;
                        this.city = value[1].name;
                        this.cityCode = value[1].code;
                        this.area = value[2].name;
                        this.areaCode = value[2].code;
                        this.userCity = value[0].name + value[1].name + value[2].name;
                    }
                } else {
                    this.userCity = value[0].name + value[1].name;
                }
                this.showCityChoose = false;
            },
            onConfirmMoney(value) {
                this.userMoney = value.text;
                this.showMoneyPicker = false;
            },
            onConfirmDate(value) {
                this.userDate = value.text;
                this.showDatePicker = false;
                this.workInfoShow = true;
                this.getWorkInfo();
            },
            getAgencyListInfo() {
                this.isShowLoading = true;
                this.$get('/app/api/v1/order/zyb/agencyInfos')
                    .then(res => {
                        if (res.code == 200) {
                            this.agencyListInfo = res.data;
                            this.isShowLoading = false;
                            if (this.agencyListInfo.length > 0) {
                                this.agencyToastShow = true;
                            } else {
                                this.authSuccess();
                            }
                        }
                    })
                    .catch(error => {
                    });
            },
            getNewInfo() {
                this.$get("/app/v1/appHead/product/bySite?site=1")
                    .then((res) => {
                        if (res.code == 200) {
                            let data = res.data;
                            if (data) {
                                this.productId = data.productId;
                                this.loginPhone = data.loginPhone;
                                let params = {
                                    productId: this.productId
                                };
                                this.$get("/app/v1/product/baseinfo/getAllBaseInfo", params)
                                    .then((res) => {
                                        if (res.code == 200) {
                                            /*console.log("调用getAllBaseInfo方法成功后")
                                            let resInfo = res.data.baseInfoConfig[0].list;
                                            resInfo[1].showConfig.split(",").forEach((item, index) => {
                                              this.columnsMoney.push({ num: index, text: item });
                                            });
                                            resInfo[2].showConfig.split(",").forEach((item, index) => {
                                              this.columnsDate.push({ num: index, text: item });
                                            });*/
                                            let resInfo = res.data.baseInfoConfig[0].list;
                                            for (var i = 0; i < resInfo.length; i++) {
                                                if (resInfo[i] && resInfo[i].paramField.includes("money")) {
                                                    resInfo[i].showConfig.split(",").forEach((item, index) => {
                                                        this.columnsMoney.push({num: index, text: item});
                                                    });
                                                }
                                                if (resInfo[i] && resInfo[i].paramField.includes("stage")) {
                                                    resInfo[i].showConfig.split(",").forEach((item, index) => {
                                                        this.columnsDate.push({num: index, text: item});
                                                    });
                                                }
                                            }
                                        }
                                    });
                            }
                        }
                    });
            },
            authXindai() {
                let canSubmit = true;
                if (this.education == "") {
                    this.util.toast({msg: "学历" + this.tips});
                    canSubmit = false;
                } /*else if (this.loanCondition == "") {
                    this.util.toast({msg: "近30天借款情况" + this.tips});
                    canSubmit = false;
                } else if (this.creditRecord == "") {
                    this.util.toast({msg: "信用记录" + this.tips});
                    canSubmit = false;
                } */else if (this.useValue == "") {
                    this.util.toast({msg: "借款用途" + this.tips});
                    canSubmit = false;
                } else if (this.perValue == "") {
                    canSubmit = false;
                    this.util.toast({msg: "职业身份" + this.tips});
                } else if (this.incomeValue == "") {
                    canSubmit = false;
                    if (this.showSampleTxt) {
                        this.util.toast({msg: "月收入" + this.tips});
                    } else {
                        this.util.toast({msg: "总经营流水" + this.tips});
                    }
                } else {
                    this.newNum.forEach((item, index) => {
                        if (item.num == -1) {
                            canSubmit = false;
                            this.util.toast({msg: this.newNum[index].title + this.tips});
                        }
                    });
                }

                if (canSubmit) {
                    let assetInfoArr = [
                        {
                            key: "名下房产",
                            value: this.newNum.filter((title) => title.title == "房产情况")[0]
                                .name,
                        },
                        {
                            key: "名下车产",
                            value: this.newNum.filter((title) => title.title == "车辆情况")[0]
                                .name,
                        },
                        {
                            key: "信用卡额度",
                            value: this.newNum.filter((title) => title.title == "信用卡")[0]
                                .name,
                        },
                        {
                            key: "微粒贷额度",
                            value: this.newNum.filter((title) => title.title == "微粒贷")[0]
                                .name,
                        },
                        {
                            key: "保险保单",
                            value: this.newNum.filter((title) => title.title == "保险保单")[0]
                                .name,
                        },
                    ];
                    let baseInfoArr = [
                        {
                            key: this.showSampleTxt == true ? "月收入" : "总经营流水",
                            value: this.incomeValue,
                        },
                        {
                            //社保
                            key: "社保",
                            value: this.newNum.filter((title) => title.title == "社保")[0].name,
                        },
                        {
                            key: "公积金",
                            value: this.newNum.filter((title) => title.title == "公积金")[0]
                                .name,
                        },
                        {
                            key: "芝麻分",
                            value: this.newNum.filter((title) => title.title == "芝麻分")[0]
                                .name,
                        },
                        {
                            key: "职业身份",
                            value: this.perValue,
                        },
                    ];
                    if (this.perValue == "上班族" || this.perValue == "公务员" || this.perValue == "事业单位") {
                        let addParm = [
                            {
                                key: "当前单位工龄",
                                value: this.newNum.filter(
                                    (title) => title.title == "当前单位工龄"
                                )[0].name,
                            },
                            {
                                key: "工资发放形式",
                                value: this.newNum.filter(
                                    (title) => title.title == "工资发放形式"
                                )[0].name,
                            },
                        ];

                        addParm.forEach((item, index) => {
                            baseInfoArr.push(item);
                        });
                    } else if (this.perValue == "企业主" || this.perValue == "个体户") {
                        let addParm2 = [
                            {
                                key: "经营年限",
                                value: this.newNum.filter((title) => title.title == "经营年限")[0]
                                    .name,
                            },
                            {
                                key: "营业执照注册年限",
                                value: this.newNum.filter(
                                    (title) => title.title == "营业执照注册年限"
                                )[0].name,
                            },
                        ];
                        addParm2.forEach((item, index) => {
                            baseInfoArr.push(item);
                        });
                    }
                    let param = {
                        loanPurpose: this.useValue,
                        professIdentity: this.perValue,
                        monthIncome: this.incomeValue,
                        socialSecurity: this.newNum.filter(
                            (title) => title.title == "社保"
                        )[0].name,
                        creditCard: this.newNum.filter((title) => title.title == "信用卡")[0]
                            .name,
                        housSituation: this.newNum.filter(
                            (title) => title.title == "房产情况"
                        )[0].name,
                        carSituation: this.newNum.filter(
                            (title) => title.title == "车辆情况"
                        )[0].name,
                        particleBorrow: this.newNum.filter(
                            (title) => title.title == "微粒贷"
                        )[0].name,
                        operationCuration: this.newNum.filter(
                            (title) => title.title == "保险保单"
                        )[0].name,
                        accumuFund: this.newNum.filter((title) => title.title == "公积金")[0]
                            .name,
                        baseInfo: JSON.stringify(baseInfoArr),
                        assetInfo: JSON.stringify(assetInfoArr),
                        authId: this.authId,
                        carModel: this.carModel,
                        education: this.education,
                        loanCondition: this.loanCondition,
                        creditRecord: this.creditRecord
                    };
                    this.carSituation = param.carSituation;
                    // let json = JSON.stringify(param);
                    return this.$post("/app/api/v1/authXindai", param).then((res) => {
                        if (res.code == 200) {

                        } else {
                            this.util.toast({msg: res.message});
                        }
                        return res;
                    });
                }
            },
            saveCustomerBaseInfo() {
                let canSubmit = true;
                if (this.userCity == "") {
                    this.util.toast({msg: "工作地址" + this.tips});
                    canSubmit = false;
                    return;
                }
                if (this.userCity == "nullnull") {
                    this.util.toast({msg: "工作地址" + this.tips});
                    canSubmit = false;
                    return;
                }
                if (this.city == "") {
                    this.util.toast({msg: "工作地址" + this.tips});
                    canSubmit = false;
                    return;
                }
                if (this.userMoney == "") {
                    canSubmit = false;
                    this.util.toast({msg: "借款金额" + this.tips});
                    return;
                }
                if (this.userDate == "") {
                    canSubmit = false;
                    this.util.toast({msg: "借款期限" + this.tips});
                    return;
                }
                let newInfoArr = {
                    //新增字段
                    workCity: this.userCity,
                };
                let moneyProduct = "money" + this.productId;
                newInfoArr[moneyProduct] = this.userMoney;
                let stageProduct = "stage" + this.productId;
                newInfoArr[stageProduct] = this.userDate;
                const baseParam = {
                    proBaseInfo: JSON.stringify(newInfoArr),
                    /*loginPhone: this.loginPhone,*/
                    province: this.province,
                    city: this.city,
                    area: this.area,
                    provinceCode: this.provinceCode,
                    cityCode: this.cityCode,
                    areaCode: this.areaCode,
                    productId: this.productId
                }
                //let param=this.transformRequest(baseParam);
                return this.$post("/app/v1/product/baseinfo/saveCustomerBaseInfo", baseParam).then((res) => {
                    if (res.code == 200) {

                    } else {
                        this.util.toast({msg: res.message});
                    }
                    return res;
                });
            },//成单接口
            postOrder() {
                let orderParam = {
                    productId: this.productId,
                    flag: "newAssetInfo",
                };
                this.$post("/app/api/v1/order/postOrder", orderParam)
                    .then((res) => {
                        if (res.code == 200) {
                            //this.pageUrl = data.pageUrl;
                            window.location.href = res.data.pageUrl;
                            //this.redirect();
                            /*if (this.agencyListInfo.length > 0) {
                                this.agencyToastShow = true;
                            } else {
                                this.redirect();
                            }*/
                        } else {
                            this.util.toast({msg: res.message});
                        }
                    });
            },
            transformRequest(data) {  //对参数进行处理
                let ret = "";
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        "=" +
                        encodeURIComponent(data[it]) +
                        "&";
                }
                ret = ret.substring(0, ret.lastIndexOf("&"));
                return ret;
            },//调用android和ios的方法
            authSuccess() {
                try {
                    window.webkit.messageHandlers.authSuccess.postMessage(""); //ios
                } catch (err) {
                    window.AppJs.authSuccess(); //android
                }
            }, xgfaMethod() {
                //this.redirect();
                this.authSuccess();
            },
            checkCarToast() {
                this.isCarLoading = true;
                this.$get("/app/v1/product/baseinfo/checkCarToast", {
                    city: this.city,
                    productId: this.productId,
                    money: this.userMoney
                }).then((res) => {
                    if (res.code == 200 && res.data == true) {
                        this.isCarLoading = false;
                        //this.showToast = true;
                        this.showCarModel = true;
                    } else {
                        //this.util.toast({msg: res.msg});
                        this.isCarLoading = false;
                        //this.authSuccess();
                        this.showCarModel = false;
                    }
                });
            },
            redirect() {
                this.util.toast({msg: "正在为您跳转下一步"});
                if (this.pageUrl.includes("yuansheng")) {
                    this.authSuccess();
                } else {
                    window.location.href = this.pageUrl;
                }
            },
            closeToast() {
                console.log("点击关闭按钮")
                this.authSuccess();
            },
            toastSubmit() {
                console.log("点击提交按钮")
                let param = {
                    carModel: this.carModel
                };
                this.$post("/app/v1/product/baseinfo/addCarModel", param).then((res) => {
                    if (res.code == 200) {
                        this.authSuccess();
                    } else {
                        this.util.toast({msg: res.message});
                    }
                });
            },
            skipSubmit() {
                console.log("点击跳过按钮")
                this.authSuccess();
            }, startLocation() {
                this.isCarLoading = true;
                try {
                    try {
                        window.webkit.messageHandlers.startLocation.postMessage(""); //ios
                    } catch (err) {
                        window.AppJs.startLocation(); //android
                    }
                } catch (e) {
                    this.isCarLoading = false;
                }
            }, saveLocation(str) {
                this.isCarLoading = false;
                if (str) {
                    this.hasLocation = true;
                }
                var param = JSON.parse(str);
                var city = [{code: param.cityCode, name: param.province}, {
                    code: param.cityCode,
                    name: param.city
                }, {code: param.cityCode, name: param.district}]
                this.confirmCity(city)
            }, choiceCity() {
                if (this.hasLocation) {
                    this.showCityChoose = false;
                } else {
                    this.showCityChoose = true
                }
            },

        },
    };
</script>
